// extracted by mini-css-extract-plugin
export default {"root":"ReferenceItem_root__Y15Gk","active":"ReferenceItem_active__jIQPq","title":"ReferenceItem_title__UL7P9"};